<ng-template #modalTemplate>
  <aran-modal
    [templateRef]="modalfields"
    [modalTitle]="'Confirmation'"
    [modalAction]="{
    showActions: false,
  }"
  ></aran-modal>

  <ng-template #modalfields>
    <form [formGroup]="form" (ngSubmit)="registerConfirm()">
      <div
        fxLayout="row wrap"
        class="form-fields"
        fxLayoutAlign="space-between center"
      >
        <aran-input
          class="w-full"
          type="text"
          label="Enter Code"
          formControlName="confirmationCode"
          [errorMessages]="{
          required: errorMessages.required('Code'),
        }"
        ></aran-input>

        <div fxFlex="100%" class="confirmation-form">
          <aran-button
            [type]="'submit'"
            [name]="'Confirm'"
            [disabled]="!form.get('confirmationCode')?.value"
            [className]="
              !form.get('confirmationCode')?.value ? 'btn_disabled' : ''
            "
          ></aran-button>
        </div>
      </div>
    </form>
  </ng-template>
</ng-template>

<ng-template #notificationTemplate>
  <div class="app-form-container app-form-notification-container">
    <div>Thank you for registering!</div>
    <div>
      Your registration has been successfully completed. Our administrative team
      is currently reviewing your request to ensure all necessary details are in
      place. Once the review is complete, you will receive a detailed
      update via email.
    </div>
  </div>
</ng-template>

<div
  class="app-form-container"
  *ngIf="!isVisibleNotification; else notificationTemplate"
>
  <h1 class="app-form-container__title">{{ appInfo.appName }}</h1>
  <p class="app-form-container__desc">Application Form</p>

  <form
    [formGroup]="form"
    (ngSubmit)="register()"
    fxLayout="column"
    fxLayoutAlign="center"
  >
    <div class="app-form-container__banner">
      <div class="app-form-container__banner--title">Administrative email</div>
    </div>

    <aran-input
      type="text"
      placeholder="Enter your email"
      label="Email"
      formControlName="email"
      [errorMessages]="{
        required: errorMessages.required('Email'),
        email: errorMessages.email
      }"
    ></aran-input>

    <div class="app-form-container__banner">
      <div class="app-form-container__banner--title">
        Organization Information
      </div>
    </div>

    <div class="app-form-container__row">
      <div class="app-form-container__grid">
        <aran-input
          type="text"
          placeholder="Enter organization name"
          label="Name"
          formControlName="organizationName"
          [errorMessages]="{
            required: errorMessages.required('Name'),
          }"
        >
        </aran-input>
      </div>
      <div class="app-form-container__grid">
        <aran-input
          type="text"
          placeholder="Enter organization email"
          label="Email"
          formControlName="organizationEmail"
          [errorMessages]="{
            required: errorMessages.required('Email'),
            email: errorMessages.email
          }"
        ></aran-input>
      </div>
      <div class="app-form-container__grid">
        <aran-input
          type="text"
          placeholder="Enter organization address"
          label="Address"
          formControlName="organizationAddress"
          [errorMessages]="{
            required: errorMessages.required('Address'),
          }"
        >
        </aran-input>
      </div>
      <div class="app-form-container__grid">
        <aran-input
          type="text"
          placeholder="Enter organization website"
          label="Website"
          formControlName="organizationWebsite"
          [errorMessages]="{
            invalidUrl: errorMessages.invalidUrl
          }"
        ></aran-input>
      </div>
    </div>

    <div class="app-form-container__banner">
      <div class="app-form-container__banner--title">
        Responsible for general Service consumption matters
      </div>
    </div>

    <div class="app-form-container__row">
      <div class="app-form-container__grid">
        <aran-input
          type="text"
          placeholder="Enter service name"
          label="Name"
          formControlName="generalSRName"
          [errorMessages]="{
            required: errorMessages.required('Name'),
          }"
        >
        </aran-input>
      </div>
      <div class="app-form-container__grid">
        <aran-input
          type="text"
          placeholder="Enter service surname"
          label="Surname"
          formControlName="generalSRSurName"
          [errorMessages]="{
            required: errorMessages.required('Surname'),
          }"
        ></aran-input>
      </div>
      <div class="app-form-container__grid">
        <aran-input
          type="text"
          placeholder="Enter service email"
          label="Email"
          formControlName="generalSREmail"
          [errorMessages]="{
            required: errorMessages.required('Email'),
            email: errorMessages.email
          }"
        ></aran-input>
      </div>
      <div class="app-form-container__grid">
        <aran-input
          type="text"
          placeholder="Enter service phone"
          label="Phone"
          formControlName="generalSRPhone"
          [errorMessages]="{
            phoneNumber: errorMessages.phoneNumber
          }"
        ></aran-input>
      </div>
    </div>

    <div class="app-form-container__banner">
      <div class="app-form-container__banner--title">
        Responsible for technical matters
      </div>
    </div>

    <div class="app-form-container__row">
      <div class="app-form-container__grid">
        <aran-input
          type="text"
          placeholder="Enter technical name"
          label="Name"
          formControlName="technicalSRName"
          [errorMessages]="{
            required: errorMessages.required('Name'),
          }"
        ></aran-input>
      </div>
      <div class="app-form-container__grid">
        <aran-input
          type="text"
          placeholder="Enter technical surname"
          label="Surname"
          formControlName="technicalSRSurName"
          [errorMessages]="{
            required: errorMessages.required('Surname'),
          }"
        ></aran-input>
      </div>
      <div class="app-form-container__grid">
        <aran-input
          type="text"
          placeholder="Enter technical email"
          label="Email"
          formControlName="technicalSREmail"
          [errorMessages]="{
            required: errorMessages.required('Email'),
            email: errorMessages.email
          }"
        ></aran-input>
      </div>
      <div class="app-form-container__grid">
        <aran-input
          type="text"
          placeholder="Enter technical phone"
          label="Phone"
          formControlName="technicalSRPhone"
          [errorMessages]="{
            phoneNumber: errorMessages.phoneNumber
          }"
        ></aran-input>
      </div>
      <div class="app-form-container__grid"></div>
    </div>

    <div class="app-form-container__banner">
      <div class="app-form-container__banner--title">Services</div>
    </div>

    <div class="create-service-container">
      <div fxLayout="column" fxLayoutAlign="center">
        <div
          class="create-service-container__service-category"
          [ngClass]="{ 'error-border': hasTopicErrors() }"
          *ngFor="let item of allServices?.topics; let i = index"
        >
          <div class="create-service-container__service-category-title">
            {{ item.description }}
          </div>

          <div class="flex-col">
            <ng-container *ngIf="!item?.topicAreas?.length">
              <ng-container
                *ngTemplateOutlet="scenariosContentTemplate"
              ></ng-container>
            </ng-container>

            <aran-tabs
              *ngIf="item?.topicAreas?.length"
              [tabs]=" [
            {
              label: 'Scenarios',
              template: scenariosContentTemplate,
            },
            {
              label: 'Airports',
              template: airportsContentTemplate,
            },
            {
              label: 'FIRs',
              template: firsContentTemplate,
            },
          ]"
              [selectedIndex]="selectedIndexes[i]"
              (tabChanged)="onTabChanged($event, i)"
              [design]="'underline'"
              [fitInkBarToContent]="true"
              [stretchTabs]="false"
              [alignTabs]="'start'"
              [dynamicHeight]="false"
              [animationDuration]="'300ms'"
              [ignoreContentAnimation]="true"
            >
            </aran-tabs>

            <ng-template #scenariosContentTemplate>
              <div class="flex flex-col mt-4">
                <div
                  *ngIf="item.subTopicSelectionOptions.length > 0"
                  class="flex justify-between items-center pb-4"
                >
                  <mat-radio-group
                    name="subTopicRadioGroup_{{ i }}"
                    (change)="
                      onSubTopicSelectionChange(
                        $event.value,
                        i,
                        getScenarioKey(i)
                      )
                    "
                    [value]="
                      form.get('topics')?.value[i]?.subTopicSelectedOption
                    "
                  >
                    <mat-radio-button
                      *ngFor="let option of item.subTopicSelectionOptions"
                      [value]="option.value"
                      class="mr-4 block app-form-radio"
                      color="primary"
                    >
                      {{ option.name }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>

                <div
                  class="flex flex-col"
                  *ngIf="
                    (item.subTopicSelectionOptions.length > 0 &&
                      getSubTopicSelectedOption(i) === 2) ||
                    item.subTopicSelectionOptions.length === 0
                  "
                >
                  <div
                    class="checkboxHeader-container flex justify-end items-center pb-2 pt-2"
                    *ngIf="item.subTopics.length > 1"
                  >
                    <div class="detailTableSearchContainer">
                      <aran-input
                        type="text"
                        label="Search"
                        fxFlex="100%"
                        [outline]="true"
                        [isClearable]="true"
                        [(ngModel)]="filters[getScenarioKey(i)]"
                        [ngModelOptions]="{ standalone: true }"
                        (input)="applyFilter(getScenarioKey(i))"
                        (handleReset)="resetFilter(getScenarioKey(i))"
                      ></aran-input>
                    </div>
                  </div>
                  <ng-container
                    *ngIf="
                      (
                        item.subTopics
                        | filterByText
                          : filters[getScenarioKey(i)]
                          : 'description'
                      ).length;
                      else noInfoFoundTemplate
                    "
                  >
                    <div class="mt-4 flex flex-col">
                      <mat-checkbox
                        class="app-form-checkbox"
                        *ngFor="
                          let service of item.subTopics
                            | filterByText
                              : filters[getScenarioKey(i)]
                              : 'description'
                            | paginate : pagingConfig[getScenarioKey(i)]
                        "
                        color="primary"
                        (change)="
                          onSubTopicCheckboxChange($event, i, service.id)
                        "
                        [checked]="getSubTopicIds(i).includes(service.id!)"
                      >
                        {{ service.description }}
                      </mat-checkbox>
                    </div>
                  </ng-container>

                  <aran-pagination
                    *ngIf="
                      (
                        item.subTopics
                        | filterByText
                          : filters[getScenarioKey(i)]
                          : 'description'
                      ).length > itemsPerPage
                    "
                    [uniqueKey]="getScenarioKey(i)"
                    [totalItems]="
                      (
                        item.subTopics
                        | filterByText
                          : filters[getScenarioKey(i)]
                          : 'description'
                      ).length
                    "
                    [currentPage]="pagingConfig[getScenarioKey(i)].currentPage"
                    [itemsPerPage]="
                      pagingConfig[getScenarioKey(i)].itemsPerPage
                    "
                    [pageSizeOptions]="pageSizeOptions"
                    [maxSize]="maxSize"
                    [footerTablePagination]="
                      pagingConfig[getScenarioKey(i)].footerTablePagination
                    "
                    (handlePaginate)="
                      onHandlePaginate($event, getScenarioKey(i))
                    "
                    (handleChangePageSize)="
                      onHandlePageSize($event, getScenarioKey(i))
                    "
                  ></aran-pagination>
                </div>
              </div>
            </ng-template>

            <ng-template #airportsContentTemplate>
              <div class="flex items-center p-2 airports_info-container">
                <mat-icon class="mr-1 shrink-0">info</mat-icon>
                <span>{{ airportsInfoText }}</span>
              </div>
              <div class="flex flex-col mt-4">
                <div
                  class="flex justify-between items-center pb-4"
                  *ngIf="item.topicAreaSelectionOptions.length > 0"
                >
                  <mat-radio-group
                    name="subAreaAeodromeHeliportRadioGroup_{{ i }}"
                    (change)="
                      onTopicAreaSelectionChange(
                        $event.value,
                        i,
                        item.topicAreas
                      )
                    "
                    [value]="
                      form.get('topics')?.value[i]?.topicAreaSelectedOption
                    "
                  >
                    <mat-radio-button
                      *ngFor="let option of item.topicAreaSelectionOptions"
                      [value]="option.value"
                      class="mr-4 block app-form-radio"
                      color="primary"
                    >
                      {{ option.name }}
                    </mat-radio-button>
                  </mat-radio-group>
                </div>

                <div
                  class="flex flex-col"
                  *ngIf="
                    (item.topicAreaSelectionOptions.length > 0 &&
                      getTopicAreasSelectedOption(i) === 4) ||
                    item.subTopicSelectionOptions.length === 0
                  "
                >
                  <div
                    class="checkboxHeader-container flex justify-end items-center pb-2 pt-2"
                    *ngIf="
                      (item.topicAreas | areaType : ['Aerodrome', 'Heliport'])
                        .length > 1
                    "
                  >
                    <div class="detailTableSearchContainer">
                      <aran-input
                        type="text"
                        label="Search"
                        fxFlex="100%"
                        [outline]="true"
                        [isClearable]="true"
                        [(ngModel)]="filters[getAirportKey(i)]"
                        [ngModelOptions]="{ standalone: true }"
                        (input)="applyFilter(getAirportKey(i))"
                        (handleReset)="resetFilter(getAirportKey(i))"
                      ></aran-input>
                    </div>
                  </div>
                  <ng-container
                    *ngIf="
                      (
                        item?.topicAreas
                        | areaType : ['Aerodrome', 'Heliport']
                        | filterByText : filters[getAirportKey(i)] : 'code'
                      ).length;
                      else noInfoFoundTemplate
                    "
                  >
                    <div class="mt-4 flex flex-col">
                      <mat-checkbox
                        class="app-form-checkbox"
                        *ngFor="
                          let item of item?.topicAreas
                            | areaType : ['Aerodrome', 'Heliport']
                            | filterByText : filters[getAirportKey(i)] : 'code'
                            | paginate : pagingConfig[getAirportKey(i)]
                        "
                        color="primary"
                        (change)="onAreaCheckboxChange($event, i, item.id)"
                        [checked]="isAreaChecked(i).includes(item.id!)"
                      >
                        {{ item.code }}
                      </mat-checkbox>
                    </div>
                  </ng-container>

                  <aran-pagination
                    *ngIf="
                      (
                        item?.topicAreas
                        | areaType : ['Aerodrome', 'Heliport']
                        | filterByText : filters[getAirportKey(i)] : 'code'
                      ).length > itemsPerPage
                    "
                    [uniqueKey]="getAirportKey(i)"
                    [totalItems]="
                      (
                        item?.topicAreas
                        | areaType : ['Aerodrome', 'Heliport']
                        | filterByText : filters[getAirportKey(i)] : 'code'
                      ).length
                    "
                    [currentPage]="pagingConfig[getAirportKey(i)].currentPage"
                    [itemsPerPage]="pagingConfig[getAirportKey(i)].itemsPerPage"
                    [pageSizeOptions]="pageSizeOptions"
                    [maxSize]="maxSize"
                    [footerTablePagination]="
                      pagingConfig[getAirportKey(i)].footerTablePagination
                    "
                    (handlePaginate)="
                      onHandlePaginate($event, getAirportKey(i))
                    "
                    (handleChangePageSize)="
                      onHandlePageSize($event, getAirportKey(i))
                    "
                  ></aran-pagination>
                </div>
              </div>
            </ng-template>

            <ng-template #firsContentTemplate>
              <div class="flex items-center p-2 airports_info-container">
                <mat-icon class="mr-1 shrink-0">info</mat-icon>
                <span>{{ airportsInfoText }}</span>
              </div>
              <div class="flex flex-col">
                <div
                  class="checkboxHeader-container cancel-top-border flex justify-end items-center pb-2 pt-2"
                  *ngIf="(item.topicAreas | areaType : 'Airspace').length > 1"
                >
                  <div class="detailTableSearchContainer">
                    <aran-input
                      type="text"
                      label="Search"
                      fxFlex="100%"
                      [outline]="true"
                      [isClearable]="true"
                      [(ngModel)]="filters[getFirKey(i)]"
                      [ngModelOptions]="{ standalone: true }"
                      (input)="applyFilter(getFirKey(i))"
                      (handleReset)="resetFilter(getFirKey(i))"
                    ></aran-input>
                  </div>
                </div>
                <ng-container
                  *ngIf="
                    (
                      item?.topicAreas
                      | areaType : 'Airspace'
                      | filterByText : filters[getFirKey(i)] : 'code'
                    ).length;
                    else noInfoFoundTemplate
                  "
                >
                  <div class="mt-4 flex flex-col">
                    <mat-checkbox
                      class="app-form-checkbox"
                      *ngFor="
                        let item of item?.topicAreas
                          | areaType : 'Airspace'
                          | filterByText : filters[getFirKey(i)] : 'code'
                          | paginate : pagingConfig[getFirKey(i)]
                      "
                      color="primary"
                      (change)="onAreaCheckboxChange($event, i, item.id)"
                      [checked]="isAreaChecked(i).includes(item.id!)"
                    >
                      {{ item.code }}
                    </mat-checkbox>
                  </div>
                </ng-container>

                <aran-pagination
                  *ngIf="
                    (
                      item?.topicAreas
                      | areaType : 'Airspace'
                      | filterByText : filters[getFirKey(i)] : 'code'
                    ).length > itemsPerPage
                  "
                  [uniqueKey]="getFirKey(i)"
                  [totalItems]="
                    (
                      item?.topicAreas
                      | areaType : 'Airspace'
                      | filterByText : filters[getFirKey(i)] : 'code'
                    ).length
                  "
                  [currentPage]="pagingConfig[getFirKey(i)].currentPage"
                  [itemsPerPage]="pagingConfig[getFirKey(i)].itemsPerPage"
                  [pageSizeOptions]="pageSizeOptions"
                  [maxSize]="maxSize"
                  [footerTablePagination]="
                    pagingConfig[getFirKey(i)].footerTablePagination
                  "
                  (handlePaginate)="onHandlePaginate($event, getFirKey(i))"
                  (handleChangePageSize)="
                    onHandlePageSize($event, getFirKey(i))
                  "
                ></aran-pagination>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
      <div>
        <mat-error
          class="topicsMatError"
          *ngIf="shouldShowTopicsError('subTopic2MustHaveIds')"
        >
          At least one sub-topic must be entered for the sub-topic selected as
          'Custom'.
        </mat-error>

        <mat-error
          class="topicsMatError"
          *ngIf="shouldShowTopicsError('topicAreaSelectionInvalid')"
        >
          A topic area suitable for the selected fields must be chosen.
        </mat-error>

        <mat-error
          class="topicsMatError"
          *ngIf="shouldShowTopicsError('subTopicRequiredForTopicArea')"
        >
          A sub-topic must be selected for the chosen topic area.
        </mat-error>

        <mat-error
          class="topicsMatError"
          *ngIf="shouldShowTopicsError('atLeastOneSubTopicRequired')"
        >
          At least one sub-topic must be selected.
        </mat-error>
      </div>
    </div>

    <div>
      <mat-checkbox
        class="app-form-container__rememberme"
        color="primary"
        formControlName="isAcceptRules"
      >
      </mat-checkbox>
      <span class="app-form-container__rememberme--text">I agree to the</span>
      <span
        (click)="download()"
        class="app-form-container__redirect-register--link"
        >Terms & Conditions</span
      >
    </div>

    <div class="mt-2">
      <aran-button
        class="w-full"
        [type]="'submit'"
        [name]="'Apply'"
        [disabled]="!form.valid"
      ></aran-button>
    </div>

    <div class="app-form-container__redirect-register mt-5">
      <span class="app-form-container__redirect-register--question"
        >Already have an account?</span
      >
      <a
        [routerLink]="[routeMetaData.login.link]"
        class="app-form-container__redirect-register--link"
        >{{ routeMetaData.login.title }}</a
      >
    </div>
  </form>
  <ng-template #noDataTemplate>
    <ng-container *ngIf="!(isLoading$ | async)">
      <aran-no-data text="No information found"></aran-no-data>
    </ng-container>
  </ng-template>

  <ng-template #noInfoFoundTemplate>
    <ng-container *ngIf="!(isLoading$ | async)">
      <div class="noInfoFound py-4 px-4">No matching results found.</div>
    </ng-container>
  </ng-template>
</div>
